import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'chef-hat',
  size: 24,
  node: [
    ['path', { d: 'M10 11v5', key: 'urfl79' }],
    ['path', { d: 'M14 11v5', key: 'w9lfkh' }],
    [
      'path',
      {
        d: 'M6 12.65c0-.457-.316-.844-.727-1.041A4 4 0 017.52 4.034a1.53 1.53 0 001.367-.547 4 4 0 016.225 0 1.53 1.53 0 001.367.547 4 4 0 012.248 7.575c-.411.197-.727.584-.727 1.04V19a2 2 0 01-2 2H8a2 2 0 01-2-2z',
        key: '1dq1bt',
      },
    ],
    ['path', { d: 'M6 16h12', key: 'u522kt' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ChefHat
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTF2NSIgLz4KICA8cGF0aCBkPSJNMTQgMTF2NSIgLz4KICA8cGF0aCBkPSJNNiAxMi42NWMwLS40NTctLjMxNi0uODQ0LS43MjctMS4wNDFBNCA0IDAgMDE3LjUyIDQuMDM0YTEuNTMgMS41MyAwIDAwMS4zNjctLjU0NyA0IDQgMCAwMTYuMjI1IDAgMS41MyAxLjUzIDAgMDAxLjM2Ny41NDcgNCA0IDAgMDEyLjI0OCA3LjU3NWMtLjQxMS4xOTctLjcyNy41ODQtLjcyNyAxLjA0VjE5YTIgMiAwIDAxLTIgMkg4YTIgMiAwIDAxLTItMnoiIC8+CiAgPHBhdGggZD0iTTYgMTZoMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/chef-hat
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChefHat = createLucideIcon(__iconData);

export default ChefHat;
